import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-apple-signin',
  templateUrl: './apple-signin.component.html',
  imports: [MatButtonModule,MatIconModule],
  styleUrls: ['./apple-signin.component.scss']
})
export class AppleSignInComponent {
get onClick(){
  return 'clicked';
}

}
